import { isLogicGroup } from '../../filterQueryFormat/logic/LogicGroup';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const getFirstErrorMessageFromRefinements = refinementsLogicGroup => {
  const refinements = refinementsLogicGroup.conditions.valueSeq().toArray();
  if (refinementsLogicGroup.errors.length) {
    return refinementsLogicGroup.errors[0].message;
  }
  return refinements.reduce((acc, refinement) => {
    if (isOperator(refinement) && refinement.errors.length) {
      return refinement.errors[0].message;
    }
    if (isLogicGroup(refinement)) {
      return getFirstErrorMessageFromRefinements(refinement);
    }
    return acc;
  }, undefined);
};
const getErrorMessage = logicGroup => {
  if (logicGroup.errors.length) {
    return logicGroup.errors[0].message;
  }
  if (logicGroup.refinements) {
    return getFirstErrorMessageFromRefinements(logicGroup.refinements);
  }
  return undefined;
};
const LogicGroupError = ({
  logicGroup,
  showLogicGroupErrors = false,
  spaceStyleProps = {
    marginBlockStart: '100'
  }
}) => {
  const errorMessage = showLogicGroupErrors ? getErrorMessage(logicGroup) : undefined;
  if (errorMessage) {
    return /*#__PURE__*/_jsx(Text, Object.assign({
      display: "block",
      typography: "heading-25",
      use: "error"
    }, spaceStyleProps, {
      children: errorMessage
    }));
  }
  return null;
};
export default LogicGroupError;